import { SET_UNSAVED_LOT_CHANGES } from "../actions/types";

interface IAction {
    type: string;
    payload: {
        hasUnsavedLotChanges: boolean;
    };
}

const initialState = {
    hasUnsavedLotChanges: false,
};

const uiReducer = (state = initialState, action: IAction) => {
    switch (action.type) {
        case SET_UNSAVED_LOT_CHANGES:
            return {
                ...state,
                hasUnsavedLotChanges: action.payload.hasUnsavedLotChanges,
            };
        default:
            return state;
    }
};

export default uiReducer;
